import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {CardSolid} from "@webs/components-library/card-solid";
import {GridColumn} from "@webs/components-library/grid-column";
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('webs-listing-cards')
export class ListingCards extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      .m-listing-cards ::slotted([slot="title"]) { margin-bottom: 1.6rem !important; }
      .m-listing-cards__card { margin-bottom: 0.8rem; }

      #cards ::slotted(*) { margin-top: 0.8rem; }

      @media only screen and (min-width: 768px){
        .m-listing-cards ::slotted([slot="title"]) { margin-bottom: 3.75rem !important; }
        #cards ::slotted(*) { margin-top: 0.85rem; }
      }
    `
  ]

  @property({attribute: 'space-top'})
  spaceTop = 'm'

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm'

  @property()
  id: string;

  protected render(): unknown {
    return html`<section id="${ifDefined(this.id)}" class="m-listing-cards ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : '' } ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : '' }">
      <div class="container">
        <slot name="title"></slot>

        <webs-grid-row id="cards">
          <slot name="card"></slot>
        </webs-grid-row>
      </div>
    </section>`
  }
}
